import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup-thank-you',
  templateUrl: './signup-thank-you.component.html',
  styleUrls: ['./signup-thank-you.component.scss']
})
export class SignupThankYouComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
